import { BaseDto } from './base.dto';

export class SpecialDto extends BaseDto {
  name: string;
  code: string;
  photoURL: string;
  merchantId: number;
  price: number;
  VATRateId: number;
  startDate: Date;
  endDate: Date;
}
